import { Box, useTheme } from 'ui';

import {
  type AspectRatioType,
  LANDSCAPE_CAMERA_FOOTER_WIDTH,
  LANDSCAPE_CAMERA_HEADER_WIDTH,
  PORTRAIT_CAMERA_FOOTER_HEIGHT,
  PORTRAIT_CAMERA_HEADER_HEIGHT,
} from '../../config';

export const VideoContainer = ({
  isPortrait,
  aspectRatio,
  children,
  zIndex,
}: {
  isPortrait: boolean;
  aspectRatio: AspectRatioType;
  zIndex: number;
  children: React.ReactNode;
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'fixed',
        top: isPortrait ? PORTRAIT_CAMERA_HEADER_HEIGHT : 0,
        bottom: isPortrait ? PORTRAIT_CAMERA_FOOTER_HEIGHT : 0,
        left: isPortrait ? 0 : LANDSCAPE_CAMERA_HEADER_WIDTH,
        right: isPortrait ? 0 : LANDSCAPE_CAMERA_FOOTER_WIDTH,
        margin: 'auto',
        aspectRatio: aspectRatio,
        height: isPortrait ? 'auto' : '100%',

        maxHeight: isPortrait
          ? `calc(100dvh - ${PORTRAIT_CAMERA_HEADER_HEIGHT} - ${PORTRAIT_CAMERA_FOOTER_HEIGHT} - 2dvh)`
          : 'none',

        padding: '1px',

        width: isPortrait
          ? 'auto'
          : `calc(100dvw - ${LANDSCAPE_CAMERA_HEADER_WIDTH} - ${LANDSCAPE_CAMERA_FOOTER_WIDTH} - 2dvw)`,

        zIndex: theme.zIndex.modal + zIndex,
      }}
    >
      {children}
    </Box>
  );
};
